import React, { lazy, Suspense } from "react";
import RouteLoading from "../components/common/RouteLoading";
import { Route, Routes, Navigate } from "react-router-dom";
import RouteNames from "./RouteName";
import Skeleton from "./Skeleton";
const HeadOfAccounts = lazy(() => import("../pages/corporate-admin/head-of-accounts"));
const Payroll = lazy(() => import("../pages/settings/Payroll"));
const PayrollEditPage = lazy(() => import("../pages/settings/Payroll/PayrollEditPage"));
const DailyAttendancePage = lazy(() => import("../pages/settings/DailyAttendance"));
const DailyAttendanceReport = lazy(() => import("../pages/settings/DailyAttendance/EmployeeReport"));
const FleetMaintenance = lazy(() => import("../pages/corporate-admin/fleetmaintenance"));
const Profile = lazy(() => import("../components/Profile"));

const Login = lazy(() => import("../pages/login/Login"));

const HomeDashboard = lazy(() => import("../pages/HomeDashboard"));

const UserAddForm = lazy(() => import("../pages/user/add"));
const UserList = lazy(() => import("../pages/user/list"));
const UserEdit = lazy(() => import("../pages/user/edit"));

const NotFound = lazy(() => import("../pages/NotFound"));

const FleetMasterAddForm = lazy(() => import("../pages/corporate-admin/fleetmaster/add"));
//import FleetMasterView from "../pages/corporate-admin/fleetmaster/edit";
const FleetMasterList = lazy(() => import("../pages/corporate-admin/fleetmaster/list"));
const VehicleTracking = lazy(() => import("../pages/corporate-admin/vehicletracking"));

const DriverMasterAddForm = lazy(() => import("../pages/corporate-admin/drivermaster/add"));
const DriverMasterList = lazy(() => import("../pages/corporate-admin/drivermaster/list"));
const DriverMasterEdit = lazy(() => import("../pages/corporate-admin/drivermaster/edit"));
const DriverMasterDetails = lazy(() => import("../pages/corporate-admin/drivermaster/details"));

const PayrollMasterListAddForm = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-list/add"));
const PayrollMasterList = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-list/list"));
const PayrollMasterListEdit = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-list/edit"));
const PayrollMasterListDetails = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-list/details"));

const PayrollStructureAddForm = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-structure/add"));
const PayrollStructureList = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-structure/list"));
const PayrollStructureEdit = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-structure/edit"));
const PayrollStructureDetails = lazy(() => import("../pages/corporate-admin/payrollmaster/payroll-structure/details"));

const HelperMasterAddForm = lazy(() => import("../pages/corporate-admin/helpermaster/add"));
const HelperMasterView = lazy(() => import("../pages/corporate-admin/helpermaster/list"));
const HelperMasterEdit = lazy(() => import("../pages/corporate-admin/helpermaster/edit"));
const HelperMasterDetails = lazy(() => import("../pages/corporate-admin/helpermaster/details"));

const CustomerMasterAddForm = lazy(() => import("../pages/corporate-admin/customermaster/add"));
const CustomerMasterView = lazy(() => import("../pages/corporate-admin/customermaster/list"));
const CustomerMasterEditForm = lazy(() => import("../pages/corporate-admin/customermaster/edit"));
const CustomerMasterDetails = lazy(() => import("../pages/corporate-admin/customermaster/details"));

const VendorMasterAdd = lazy(() => import("../pages/corporate-admin/vendormaster/add"));
const VendorMasterView = lazy(() => import("../pages/corporate-admin/vendormaster/list"));
const VendorMasterEdit = lazy(() => import("../pages/corporate-admin/vendormaster/edit"));

const LaneMasterAdd = lazy(() => import("../pages/corporate-admin/lanemaster/add"));
const LaneMasterView = lazy(() => import("../pages/corporate-admin/lanemaster/list"));
const LaneMasterEdit = lazy(() => import("../pages/corporate-admin/lanemaster/edit"));

const ContractorMasterAdd = lazy(() => import("../pages/corporate-admin/contractormaster/add"));
const ContractorMasterView = lazy(() => import("../pages/corporate-admin/contractormaster/list"));
const ContractorMasterEdit = lazy(() => import("../pages/corporate-admin/contractormaster/edit"));
const ContractorMasterDetails = lazy(() => import("../pages/corporate-admin/contractormaster/details"));

const LocationMasterAdd = lazy(() => import("../pages/corporate-admin/locationmaster/add"));
const LocationMasterView = lazy(() => import("../pages/corporate-admin/locationmaster/list"));
const LocationMasterEdit = lazy(() => import("../pages/corporate-admin/locationmaster/edit"));

const RouteMasterAdd = lazy(() => import("../pages/corporate-admin/routemaster/add"));
const RouteMasterView = lazy(() => import("../pages/corporate-admin/routemaster/list"));
const RouteMasterEdit = lazy(() => import("../pages/corporate-admin/routemaster/edit"));

const ProductMasterAdd = lazy(() => import("../pages/corporate-admin/productmaster/add"));
const ProductMasterView = lazy(() => import("../pages/corporate-admin/productmaster/list"));
const ProductMasterEdit = lazy(() => import("../pages/corporate-admin/productmaster/edit"));

const ProductCategoryMasterAdd = lazy(() => import("../pages/corporate-admin/productcategorymaster/add"));
const ProductCategoryMasterView = lazy(() => import("../pages/corporate-admin/productcategorymaster/list"));
const ProductCategoryMasterEdit = lazy(() => import("../pages/corporate-admin/productcategorymaster/edit"));

const ConsignmentMasterAdd = lazy(() => import("../pages/corporate-admin/consignmentmaster/add"));
const ConsignmentMasterView = lazy(() => import("../pages/corporate-admin/consignmentmaster/list"));
const ConsignmentMasterDetails = lazy(() => import("../pages/corporate-admin/consignmentmaster/details"));
const ConsignmentMasterInvoice = lazy(() => import("../pages/corporate-admin/consignmentmaster/invoice"));
const ConsignmentMasterEdit = lazy(() => import("../pages/corporate-admin/consignmentmaster/edit"));
const ConsignmentMasterLR = lazy(() => import("../pages/corporate-admin/consignmentmaster/lr"));

const LRCopyMasterAdd = lazy(() => import("../pages/corporate-admin/lrcopymaster/add"));
const LRCopyMasterView = lazy(() => import("../pages/corporate-admin/lrcopymaster/list"));
const LRCopyMasterEdit = lazy(() => import("../pages/corporate-admin/lrcopymaster/edit"));

const NodeMasterAdd = lazy(() => import("../pages/corporate-admin/node-master/add"));
const NodeMasterView = lazy(() => import("../pages/corporate-admin/node-master/list"));
const NodeMasterEdit = lazy(() => import("../pages/corporate-admin/node-master/edit"));

const ContractualTripAdd = lazy(() => import("../pages/trip/add"));
const ContractualTripEdit = lazy(() => import("../pages/trip/edit"));
const ContractualTripView = lazy(() => import("../pages/trip/list"));
const TripDetails = lazy(() => import("../pages/trip/details"));
const TripInvoice = lazy(() => import("../pages/trip/invoice"));
const ExpenseTypeAdd = lazy(() => import("../pages/trip/expensetype/add"));
const ExpenseTypeList = lazy(() => import("../pages/trip/expensetype/list"));
const ExpenseTypeEdit = lazy(() => import("../pages/trip/expensetype/edit"));


const CompanyMasterAdd = lazy(() => import("../pages/corporate-admin/companymaster/add"));
const CompanyMasterList = lazy(() => import("../pages/corporate-admin/companymaster/list"));
const CompanyMasterEdit = lazy(() => import("../pages/corporate-admin/companymaster/edit"));
const KiloleterMasterAdd = lazy(() => import("../pages/corporate-admin/kiloletermaster/add"));
const KiloleterMasterList = lazy(() => import("../pages/corporate-admin/kiloletermaster/list"));
const KiloleterMasterEdit = lazy(() => import("../pages/corporate-admin/kiloletermaster/edit"));
const TonnageMasterAdd = lazy(() => import("../pages/corporate-admin/tonnagemaster/add"));
const TonnageList = lazy(() => import("../pages/corporate-admin/tonnagemaster/list"));
const TonnageMasterEdit = lazy(() => import("../pages/corporate-admin/tonnagemaster/edit"));
const VehicleCategoryList = lazy(() => import("../pages/corporate-admin/vehiclecategory/list"));
const AddVehicleCategory = lazy(() => import("../pages/corporate-admin/vehiclecategory/add"));
const VehicleCategoryEdit = lazy(() => import("../pages/corporate-admin/vehiclecategory/edit"));
const LoadingReport = lazy(() => import("../pages/reports/list/loading-report"));
const VehicleShortageSummaryReport = lazy(() => import("../pages/reports/list/vehicle-shortage-summary-report"));
const TripExpensesReport = lazy(() => import("../pages/reports/list/trip-expenses-report"));
const PerformanceReport = lazy(() => import("../pages/reports/list/performance-report"));
const MonthlyLoadingReport = lazy(() => import("../pages/reports/list/monthly-loading-graph"));
const EmiReport = lazy(() => import("../pages/reports/list/emi-report"));
const FleetAssignment = lazy(() => import("../pages/corporate-admin/drivermaster/fleetAssignment"));

const CountryAdd = lazy(() => import("../pages/corporate-admin/geo-data/country/add"));
const CountryList = lazy(() => import("../pages/corporate-admin/geo-data/country/list"));
const CountryEdit = lazy(() => import("../pages/corporate-admin/geo-data/country/edit"));
const ZoneAdd = lazy(() => import("../pages/corporate-admin/geo-data/zone/add"));
const ZoneList = lazy(() => import("../pages/corporate-admin/geo-data/zone/list"));
const ZoneEdit = lazy(() => import("../pages/corporate-admin/geo-data/zone/edit"));
const StateAdd = lazy(() => import("../pages/corporate-admin/geo-data/state/add"));
const StateList = lazy(() => import("../pages/corporate-admin/geo-data/state/list"));
const StateEdit = lazy(() => import("../pages/corporate-admin/geo-data/state/edit"));
const CityAdd = lazy(() => import("../pages/corporate-admin/geo-data/city/add"));
const CityList = lazy(() => import("../pages/corporate-admin/geo-data/city/list"));
const CityEdit = lazy(() => import("../pages/corporate-admin/geo-data/city/edit"));
const PincodeAdd = lazy(() => import("../pages/corporate-admin/geo-data/pincode/add"));
const PincodeList = lazy(() => import("../pages/corporate-admin/geo-data/pincode/list"));
const PincodeEdit = lazy(() => import("../pages/corporate-admin/geo-data/pincode/edit"));
const RoleMasterList = lazy(() => import("../pages/corporate-admin/rolemaster/list"));
const RoleMasterAddEdit = lazy(() => import("../pages/corporate-admin/rolemaster/add"));
const PermissionMasterList = lazy(() => import("../pages/corporate-admin/permissionmaster/list"));
const PermissionAddEdit = lazy(() => import("../pages/corporate-admin/permissionmaster/add"));
const FleetMasterEdit = lazy(() => import("../pages/corporate-admin/fleetmaster/edit"));
const UnitManagement = lazy(() => import("../pages/settings/UnitManagement"));
const AppConfig = lazy(() => import("../pages/settings/AppConfig"));
const ProductClassification = lazy(() => import("../pages/settings/ProductClassification"));

function AppRoutes() {
   return (
      <Suspense fallback={<RouteLoading />}>
      <Routes>
         {/* Root Route Redirect */}
         <Route path="/" element={<Navigate to="/login" replace />} />

         {/* Common Routes */}
         <Route path="/login" element={<Login />} />

         {/* Protected Routes */}
         <Route element={<Skeleton />}>
            {/* Dashboard */}
            <Route path="dashboard" element={<HomeDashboard />} />

            {/* Profile */}
            <Route path={RouteNames.profileView} element={<Profile />} />
            {/* User Routes */}
            <Route path={RouteNames.userAddForm} element={<UserAddForm />} />
            <Route path={RouteNames.userList} element={<UserList />} />
            <Route path={RouteNames.userEdit} element={<UserEdit />} />

            {/* Role Master Routes */}
            <Route path={RouteNames.roleMasterList} element={<RoleMasterList />} />
            <Route path={RouteNames.roleMasterEdit} element={<RoleMasterAddEdit />} />
            <Route path={RouteNames.roleMasterAdd} element={<RoleMasterAddEdit />} />

            {/* Permission Master Routes */}
            <Route
               path={RouteNames.permissionMasterList}
               element={<PermissionMasterList />}
            />
            <Route
               path={RouteNames.permissionMasterAdd}
               element={<PermissionAddEdit />}
            />
            <Route
               path={RouteNames.permissionMasterEdit}
               element={<PermissionAddEdit />}
            />

            {/* Fleet Master Routes */}
            <Route
               path={RouteNames.fleetMasterAddForm}
               element={<FleetMasterAddForm />}
            />
            <Route path={RouteNames.fleetMasterEdit} element={<FleetMasterEdit />} />
            <Route path={RouteNames.fleetMasterList} element={<FleetMasterList />} />
            <Route path={RouteNames.fleetMaintenance} element={<FleetMaintenance />} />
            <Route path={RouteNames.fleetMaintenanceVehicle} element={<FleetMaintenance />} />
            <Route path={RouteNames.vehicleTracking} element={<VehicleTracking />} />

            {/* Driver Master Routes */}
            <Route
               path={RouteNames.driverMasterAddForm}
               element={<DriverMasterAddForm />}
            />
            <Route path={RouteNames.driverMasterView} element={<DriverMasterList />} />
            <Route path={RouteNames.driverMasterEdit} element={<DriverMasterEdit />} />
            <Route path={RouteNames.driverMasterDetails} element={<DriverMasterDetails />} />
            <Route path={RouteNames.fleetAssignment} element={<FleetAssignment />} />

            {/* Payroll Master Routes */}
            <Route path={RouteNames.payrollMasterListAddForm} element={<PayrollMasterListAddForm />} />
            <Route path={RouteNames.payrollMasterListView} element={<PayrollMasterList />} />
            <Route path={RouteNames.payrollMasterListEdit} element={<PayrollMasterListEdit />} />
            <Route path={RouteNames.payrollMasterListDetails} element={<PayrollMasterListDetails />} />

            <Route path={RouteNames.payrollStructureAddForm} element={<PayrollStructureAddForm />} />
            <Route path={RouteNames.payrollStructureView} element={<PayrollStructureList />} />
            <Route path={RouteNames.payrollStructureEdit} element={<PayrollStructureEdit />} />
            <Route path={RouteNames.payrollStructureDetails} element={<PayrollStructureDetails />} />

            {/* Helper Master Routes */}
            <Route
               path={RouteNames.helperMasterAddForm}
               element={<HelperMasterAddForm />}
            />
            <Route path={RouteNames.helperMasterView} element={<HelperMasterView />} />
            <Route path={RouteNames.helperMasterEdit} element={<HelperMasterEdit />} />
            <Route path={RouteNames.helperMasterDetails} element={<HelperMasterDetails />} />

            {/* Customer Master Routes */}
            <Route
               path={RouteNames.customerMasterAddForm}
               element={<CustomerMasterAddForm />}
            />
            <Route
               path={RouteNames.customerMasterView}
               element={<CustomerMasterView />}
            />
            <Route
               path={RouteNames.customerMasterEdit}
               element={<CustomerMasterEditForm />}
            />
            <Route
               path={RouteNames.customerMasterDetails}
               element={<CustomerMasterDetails />}
            />
            {/* Vendor Master Routes */}
            <Route path={RouteNames.vendorMasterAddForm} element={<VendorMasterAdd />} />
            <Route path={RouteNames.vendorMasterView} element={<VendorMasterView />} />
            <Route path={RouteNames.vendorMasterEdit} element={<VendorMasterEdit />} />

            {/* Lane Master Routes */}
            <Route path={RouteNames.LaneMasterAddForm} element={<LaneMasterAdd />} />
            <Route path={RouteNames.laneMasterView} element={<LaneMasterView />} />
            <Route path={RouteNames.laneMasterEdit} element={<LaneMasterEdit />} />

            {/* Contractor Master Routes */}
            <Route
               path={RouteNames.ContractorMasterAddForm}
               element={<ContractorMasterAdd />}
            />
            <Route
               path={RouteNames.contractorMasterView}
               element={<ContractorMasterView />}
            />
            <Route
               path={RouteNames.contractorMasterEdit}
               element={<ContractorMasterEdit />}
            />
            <Route
               path={RouteNames.contractorMasterDetails}
               element={<ContractorMasterDetails />}
            />

            {/* Location Master Routes */}
            <Route
               path={RouteNames.LocationMasterAddForm}
               element={<LocationMasterAdd />}
            />
            <Route
               path={RouteNames.LocationMasterView}
               element={<LocationMasterView />}
            />
            <Route
               path={RouteNames.LocationMasterEdit}
               element={<LocationMasterEdit />}
            />

            {/* Route Master Routes */}
            <Route path={RouteNames.routeMasterAddForm} element={<RouteMasterAdd />} />
            <Route path={RouteNames.routeMasterView} element={<RouteMasterView />} />
            <Route path={RouteNames.routeMasterEdit} element={<RouteMasterEdit />} />

            {/* Product Category Master Routes */}
            <Route
               path={RouteNames.productCategoryMasterAddForm}
               element={<ProductCategoryMasterAdd />}
            />
            <Route
               path={RouteNames.productCategoryMasterView}
               element={<ProductCategoryMasterView />}
            />
            <Route
               path={RouteNames.productCategoryMasterEdit}
               element={<ProductCategoryMasterEdit />}
            />

            {/* Product Master Routes */}
            <Route
               path={RouteNames.productMasterAddForm}
               element={<ProductMasterAdd />}
            />
            <Route path={RouteNames.productMasterView} element={<ProductMasterView />} />
            <Route path={RouteNames.productMasterEdit} element={<ProductMasterEdit />} />

            {/* Consignment Master Routes */}
            <Route
               path={RouteNames.consignmentMasterAddForm}
               element={<ConsignmentMasterAdd />}
            />
            <Route
               path={RouteNames.consignmentMasterView}
               element={<ConsignmentMasterView />}
            />
            <Route
               path={RouteNames.consignmentMasterDetails}
               element={<ConsignmentMasterDetails />}
            />
            <Route
               path={RouteNames.consignmentMasterInvoice}
               element={<ConsignmentMasterInvoice />}
            />
            <Route
               path={RouteNames.consignmentMasterLR}
               element={<ConsignmentMasterLR />}
            />
            <Route
               path={RouteNames.consignmentMasterEdit}
               element={<ConsignmentMasterEdit />}
            />

            {/* LR Copy Routes */}
            <Route path={RouteNames.lrCopyMasterAddForm} element={<LRCopyMasterAdd />} />
            <Route path={RouteNames.lrCopyMasterView} element={<LRCopyMasterView />} />
            <Route path={RouteNames.lrCopyMasterEdit} element={<LRCopyMasterEdit />} />

            {/* Node Master Routes */}
            <Route path={RouteNames.NodeMasterAddForm} element={<NodeMasterAdd />} />
            <Route path={RouteNames.NodeMasterView} element={<NodeMasterView />} />
            <Route path={RouteNames.NodeMasterEdit} element={<NodeMasterEdit />} />

            {/* Company Master Routes */}
            <Route
               path={RouteNames.CompanyMasterAddForm}
               element={<CompanyMasterAdd />}
            />
            <Route path={RouteNames.CompanyMasterView} element={<CompanyMasterList />} />
            <Route path={RouteNames.CompanyMasterEdit} element={<CompanyMasterEdit />} />

            {/* Kiloleter Master Routes */}
            <Route
               path={RouteNames.kiloleterMasterAddForm}
               element={<KiloleterMasterAdd />}
            />
            <Route
               path={RouteNames.kiloleterMasterView}
               element={<KiloleterMasterList />}
            />
            <Route
               path={RouteNames.kiloleterMasterEdit}
               element={<KiloleterMasterEdit />}
            />

            {/* Tonnage Master Routes */}
            <Route
               path={RouteNames.tonnageMasterAddForm}
               element={<TonnageMasterAdd />}
            />
            <Route path={RouteNames.tonnageMasterView} element={<TonnageList />} />
            <Route path={RouteNames.tonnageMasterEdit} element={<TonnageMasterEdit />} />

            {/* Vehicle Category Routes */}
            <Route
               path={RouteNames.vehicleCategoryMasterAddForm}
               element={<AddVehicleCategory />}
            />
            <Route
               path={RouteNames.vehicleCategoryMasterView}
               element={<VehicleCategoryList />}
            />
            <Route
               path={RouteNames.vehicleCategoryMasterEdit}
               element={<VehicleCategoryEdit />}
            />

            {/* Geo Data Routes */}
            <Route path={RouteNames.countryAddForm} element={<CountryAdd />} />
            <Route path={RouteNames.countryList} element={<CountryList />} />
            <Route path={RouteNames.countryEdit} element={<CountryEdit />} />
            <Route path={RouteNames.zoneAddForm} element={<ZoneAdd />} />
            <Route path={RouteNames.zoneList} element={<ZoneList />} />
            <Route path={RouteNames.zoneEdit} element={<ZoneEdit />} />
            <Route path={RouteNames.stateAddForm} element={<StateAdd />} />
            <Route path={RouteNames.stateList} element={<StateList />} />
            <Route path={RouteNames.stateEdit} element={<StateEdit />} />
            <Route path={RouteNames.cityAddForm} element={<CityAdd />} />
            <Route path={RouteNames.cityList} element={<CityList />} />
            <Route path={RouteNames.cityEdit} element={<CityEdit />} />
            <Route path={RouteNames.pincodeAddForm} element={<PincodeAdd />} />
            <Route path={RouteNames.pincodeList} element={<PincodeList />} />
            <Route path={RouteNames.pincodeEdit} element={<PincodeEdit />} />

            {/* Trip Routes */}
            <Route
               path={RouteNames.contaractualTripAdd}
               element={<ContractualTripAdd />}
            />
            <Route
               path={RouteNames.contractualTripView}
               element={<ContractualTripView />}
            />
            <Route
               path={RouteNames.contractualTripEdit}
               element={<ContractualTripEdit />}
            />
            <Route path={RouteNames.tripDetails} element={<TripDetails />} />
            <Route path={RouteNames.tripInvoice} element={<TripInvoice />} />

            <Route path={RouteNames.headOfAccounts} element={<HeadOfAccounts />} />

            {/* Expense Type Routes */}
            <Route path={RouteNames.expenseTypeAddForm} element={<ExpenseTypeAdd />} />
            <Route path={RouteNames.expenseTypeView} element={<ExpenseTypeList />} />
            <Route path={RouteNames.expenseTypeEdit} element={<ExpenseTypeEdit />} />

            {/* Reports */}
            <Route path={RouteNames.loadingReport} element={<LoadingReport />} />
            <Route
               path={RouteNames.vehicleShortageSummaryReport}
               element={<VehicleShortageSummaryReport />}
            />
            <Route
               path={RouteNames.tripExpensesReport}
               element={<TripExpensesReport />}
            />
            <Route path={RouteNames.performanceReport} element={<PerformanceReport />} />
            <Route
               path={RouteNames.monthlyLoadingGraph}
               element={<MonthlyLoadingReport />}
            />
            <Route path={RouteNames.emiReport} element={<EmiReport />} />

            {/* Settings & Generic Masters */}
            <Route path={RouteNames.unitManagement} element={<UnitManagement />} />
            <Route path={RouteNames.appConfig} element={<AppConfig />} />
            <Route path={RouteNames.productClassification} element={<ProductClassification />} />
            <Route path={RouteNames.payroll} element={<Payroll />} />
            <Route path={RouteNames.payrollEdit} element={<PayrollEditPage />} />
            <Route path={RouteNames.payrollDetails} element={<Payroll />} />
            <Route path={RouteNames.dailyAttendanceReport} element={<DailyAttendanceReport />} />
            <Route path={RouteNames.dailyAttendance} element={<DailyAttendancePage />} />
         </Route>
         <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
   );
}

export default AppRoutes;
